export enum TaskStatus {
    inactive = 0,
    completed = 1,
    active = 2,
    awaiting_client = 4,
    skipped = 5,
    client_hold = 6,
    paused = 7,
    awaiting_previous_task = 8,
    awaiting_missing_info = 21
}
